import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { MenuBackdrop } from "./components/MenuBackdrop";
import { MenuMusic } from "./components/MenuMusic";
import { GamepadNavigation } from "./components/GamepadNavigation";
import { LocalLanding } from "./pages/LocalLanding";
import { LocalCreate } from "./pages/LocalCreate";
import { LocalPlay } from "./pages/LocalPlay";
import { LocalSettings } from "./pages/LocalSettings";
import { LessonPlay } from "./pages/LessonPlay";
import { RaceLobby } from "./pages/RaceLobby";
import { RacePlay } from "./pages/RacePlay";
import { RaceResults } from "./pages/RaceResults";

/**
 * Game routing — standard menu shape.
 *
 *   /                  → main menu (Play / Battle / Settings)
 *   /create            → first-time character setup
 *   /play              → single-player level select
 *   /play/lesson/:id   → in-game (single player)
 *   /battle            → multiplayer lobby
 *   /battle/play       → in-game (multiplayer)
 *   /battle/results    → multiplayer podium
 *   /settings          → name / avatar / reset / about
 */
export function App() {
  const location = useLocation();
  const inGame = /^\/(play\/lesson|battle\/play)/.test(location.pathname);
  return (
    <>
      <MenuMusic active={!inGame} />
      <GamepadNavigation />
      {!inGame && <MenuBackdrop />}
      <div className="page-content">
        <Routes>
          <Route path="/" element={<LocalLanding />} />
          <Route path="/create" element={<LocalCreate />} />
          <Route path="/play" element={<LocalPlay />} />
          <Route path="/play/lesson/:lessonId" element={<LessonPlay />} />
          <Route path="/battle" element={<RaceLobby />} />
          <Route path="/battle/play" element={<RacePlay />} />
          <Route path="/battle/results" element={<RaceResults />} />
          <Route path="/settings" element={<LocalSettings />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </>
  );
}
